
import React, { useState, useEffect, useContext, useRef } from "react";


import Footer from "../../../components/dashboard/footer";
import Header from "../../../components/dashboard/header";
// import Sidebar from "../../../components/dashboard/sidebar";
import { useNavigate, Link, useLocation } from "react-router-dom";
import axios from 'axios';
import tmdbApi from "../../../api/tmdbApi";
import moment from "moment";

import DataTable from 'react-data-table-component';
import CPCForm from "./cpcForm";
import SweetAlert from 'react-bootstrap-sweetalert';
import Loader from "../../../components/loader";



let { lambda, appname } = window.app


const Upcomingquiz = ({ navigatePage }) => {

    const navigate = useNavigate()
    const [data, setData] = useState(null)
    const [id, setId] = useState(null)
    const [liveShow, setLiveShow] = useState(false)
    const [isLoading, setIsLoading] = useState(false);

    const [current, setCurrent] = useState(false)

    const [deleteShow, setDeleteShow] = useState(false);
    const [deleteUserId, setDeleteUserId] = useState(false);
    const [deleteSuccess, setDeleteSuccess] = useState(false);
    const [setactivePage, setnavigatePage] = useState(null);

    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [totalRows, setTotalRows] = useState(0);
    const [tableLoading, setTableLoading] = useState(false);
    const requestIdRef = useRef(0);

    const getCpcInfo = async (pageNumber = page, size = perPage, showLoader = true) => {
        const requestId = ++requestIdRef.current;
        showLoader ? setIsLoading(true) : setTableLoading(true)
        try {
            const response = await tmdbApi.cpcInfo("UPCOMING", pageNumber, size);
            // a newer request went out while this one was in flight - drop this response
            if (requestId !== requestIdRef.current) return;
            const result = response?.result;
            const rows = Array.isArray(result) ? result : (result?.data ?? []);
            // page is past the end (e.g. last row on the page was deleted) - step back one page
            if (rows.length === 0 && pageNumber > 1) {
                setPage(pageNumber - 1)
                getCpcInfo(pageNumber - 1, size, showLoader)
                return
            }
            setData(rows)
            setTotalRows(Array.isArray(result) ? rows.length : (result?.totalCount ?? rows.length))
        } catch (error) {
            console.error("Error fetching CPC info:", error)
            if (requestId !== requestIdRef.current) return;
            setData([])
        }
        if (requestId === requestIdRef.current) {
            setIsLoading(false)
            setTableLoading(false)
        }
    }

    const handlePageChange = (newPage) => {
        // the data table re-fires this on mount (React StrictMode) - ignore when nothing changed
        if (newPage === page) return;
        setPage(newPage);
        getCpcInfo(newPage, perPage, false);
    };

    const handlePerRowsChange = (newPerPage) => {
        if (newPerPage === perPage) return;
        setPerPage(newPerPage);
        setPage(1);
        getCpcInfo(1, newPerPage, false);
    };

    useEffect(() => {
        console.log('sss', setactivePage)
        if (setactivePage != null) {
            handleClick()
            // navigatePage("upcoming")
        }
    }, [setactivePage]);

    // const data = [
    //     {
    //         quizId: 'QZ101',
    //         meetingLink: 'https://meet.example.com/abc123',
    //         scheduledDateTime: '2025-05-20T14:00:00Z',
    //         liveStartTime: '14:00',
    //         liveEndTime: '16:00',
    //         status: 'Scheduled',
    //     },
    //     {
    //         quizId: 'QZ102',
    //         meetingLink: 'https://meet.example.com/xyz456',
    //         scheduledDateTime: '2025-05-21T15:30:00Z',
    //         liveStartTime: '15:30',
    //         liveEndTime: '17:00',
    //         status: 'Completed',
    //     },
    // ];
    const setLive = (row) => {
        setLiveShow(true)
        setCurrent(row)
    }
    // Column definitions
    const columns = [
        {
            name: 'Title',
            selector: row => row.title,
            sortable: true,
        },
        {
            name: 'Meeting Link',
            selector: row => row.meetingLink,
            cell: row => <a href={row.meetingLink} target="_blank" rel="noopener noreferrer">{row.meetingLink}</a>,
        },
        {
            name: 'Scheduled Date',
            selector: row => row.scheduleDate ? dateFormat(row.scheduleDate) : "",
        },
        {
            name: 'Start Time',
            selector: row => row.scheduleStartTime,
        },
        {
            name: 'End Time',
            selector: row => row.scheduleEndTime,
        },

        {
            name: 'Live',
            selector: row => <a onClick={() => setLive(row)} className="edit-button" title="Go Live" style={{ cursor: "pointer" }}>
                <i className={`mdi mdi-record-circle font-size-13 ${row.status === "ACTIVE"}?"text-success":"text-danger"`}></i>
            </a>,
        },

        {
            name: 'Actions',
            cell: row => (
                <div className="upcoming-icons" style={{ display: 'flex' }}>
                    {/* <button onClick={() => handleView(row)} className="btn btn-sm btn-info">View</button> */}
                    {/* <button onClick={() => handleEdit(row)} className="edit-btn">Edit</button> */}
                    {/* <button onClick={() => handleDelete(row)} className="delete-btn">Delete</button> */}
                    {/* <a onClick="" className='text-success view-button'><i
                        className="mdi mdi-eye font-size-16"></i>  </a> */}
                    <a onClick={() => handleEdit(row)} className='text-danger edit-button'><i
                        className="mdi mdi-pencil font-size-16"></i> </a>

                    <a onClick={() => handleDelete(row)} className='text-danger delete-button'><i
                        className="mdi mdi-delete font-size-16"></i> </a>
                </div>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];

    const handleClick = () => {
        console.log("clickkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkk")
        getCpcInfo()
        if (id) {
            setId(null)
            console.log("clickkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkIdddddddddddddd")
        } else {
            setId("new")
            console.log("newwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwww")
        }
    };

    const [success, setSuccess] = useState(false);
    const [submitStatus, setSubmitStatus] = useState('');



    const updateActive = async () => {
        setIsLoading(true)
        let tmp = { ...current }
        tmp['status'] = "ACTIVE"
        try {
            const response = await tmdbApi['updateCpc'](JSON.stringify(tmp));
            if (!response.statusCode) throw new Error('Failed to submit quiz');

            setSubmitStatus('Quiz is now live');
            setSuccess(true);
            await getCpcInfo()
        } catch (error) {
            setSubmitStatus('Error submitting the form. Try again.');
            setSuccess(true);
        } finally {
            setIsLoading(false)
            setLiveShow(false)
        }
    }

    const dateFormat = (created) => {
        const date = new Date(created);
        // Get individual parts
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = String(date.getFullYear()).slice(-2);

        const hours = String(date.getHours()).padStart(2, '0'); // 24-hour format
        const minutes = String(date.getMinutes()).padStart(2, '0');

        // Combine into desired format
        const formattedDate = `${day}-${month}-${year}`;
        return formattedDate
    }

    useEffect(() => {
        getCpcInfo()
    }, [])

    const handleEdit = (row) => {
        setId(row.cpcid)
    };

    const handleDelete = (row) => {
        setDeleteUserId(row.cpcid)
        setDeleteShow(true)
    };


    const onDeleteCancel = (e) => {
        setDeleteShow(false)
        setDeleteUserId(null)

    }

    const onDeletePopupClose = (e) => {
        setDeleteSuccess(false)
        setDeleteUserId(null)
        getCpcInfo()
    }

    const handleDeleteConfirm = async (e) => {
        setDeleteShow(false)
        try {
            const tmp = {
                cpcid: deleteUserId
            };
            await tmdbApi.deleteCpc(JSON.stringify(tmp));

            setDeleteSuccess(true)
        } catch {
            console.log("error");
        }
    }

    return (
        <>
            {isLoading ? (
                <Loader />
            ) : (
                <>
                    {/* Button with Bootstrap classes to align right */}
                    <div className="d-flex justify-content-end mb-3">
                        <button className="create-quiz-btn border-0" onClick={handleClick} id="completed-BACK-btn">
                            {id ? "Back" : "New"}
                        </button>
                    </div>
                    {
                        id ? <CPCForm handleClick={handleClick} id={id} upcoming={true} setnavigatePage={setnavigatePage} /> : data && data.length > 0 ? (
                            <DataTable
                                key={perPage}
                                columns={columns}
                                data={data}
                                className="upcomingtable"
                                pagination
                                paginationServer
                                paginationTotalRows={totalRows}
                                paginationDefaultPage={page}
                                paginationPerPage={perPage}
                                onChangePage={handlePageChange}
                                onChangeRowsPerPage={handlePerRowsChange}
                                progressPending={tableLoading}
                                highlightOnHover
                                striped
                            />
                        ) : (
                            <div className="empty-state-body empty-record"  >
                                <div className="empty-state__message">
                                    <span className="material-icons">summarize</span>
                                    <p className="form-check font-size-16">No upcoming CPCs were found</p>
                                </div>
                            </div>
                        )}
                </>
            )}


            <SweetAlert
                show={liveShow}
                warning
                showCancel
                confirmBtnText="Yes"
                cancelBtnText="Cancel"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                title="Are you sure to want to Live?"
                focusCancelBtn
                onConfirm={e => updateActive()}
                onCancel={e => setLiveShow(false)}
            >
            </SweetAlert>

            <SweetAlert
                show={success}
                custom
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title={submitStatus}
                onConfirm={e => setSuccess(false)}
                id="error-alert"
            ></SweetAlert>


            <SweetAlert
                show={deleteShow}
                warning
                showCancel
                confirmBtnText="Yes"
                cancelBtnText="Cancel"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                title="Are you sure you want to delete?"
                focusCancelBtn
                onConfirm={e => handleDeleteConfirm(e)}
                onCancel={e => onDeleteCancel(e)}
            >
            </SweetAlert>

            <SweetAlert show={deleteSuccess}
                custom
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title={"Deleted Successfully"}
                onConfirm={e => onDeletePopupClose(e)}
            >
            </SweetAlert>

        </>
    );
};




export default Upcomingquiz;